// store/slices/organizationThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getOrganizationById, updateOrganizationV2 } from '../../services/apiServices';

/**
 * Thunks for Organization-related asynchronous operations.
 *
 * This module defines async thunks using Redux Toolkit's `createAsyncThunk`
 * to manage organization-related side effects such as fetching and updating
 * organization data via API calls.
 *
 * Thunks Included:
 * - fetchOrganizationByIdThunk: Retrieves a single organization by ID.
 * - updateOrganizationThunk: Updates organization data via PATCH request.
 *
 * Purpose:
 * Centralizes organization logic for reuse across the application,
 * ensuring consistent handling of API responses, error propagation,
 * and Redux state updates through extraReducers in the organization slice.
 */
export const fetchOrganizationByIdThunk = createAsyncThunk(
  'organization/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const organization = await getOrganizationById(id);
      return organization;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const updateOrganizationThunk = createAsyncThunk(
  'organization/updateOrganization',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const updatedOrganization = await updateOrganizationV2(id, data);
      return updatedOrganization;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
